export default class SalePrice {

    sightValue = 0
    valueWithInterest = 0
    installmentInterest = 0

    constructor(value, installmentInterest = 0) {

        this.sightValue = parseFloat(value)
        this.installmentInterest = parseFloat(installmentInterest) || 0
        this.valueWithInterest = this.sightValue + (this.sightValue * this.installmentInterest)

        Object.freeze(this)
    }


}

/*
ownPayment
    :
    "0.00"
installmentInterest
    :
    "0.5000"
maxInstallments
    :
    3
priceInterest
    :
    null
sightValue
    :
    "520.00"
    */


// WEBPACK FOOTER //
// ./src/helpers/sale-price.js